const map = {
	"./selection-col/players/Alvaro-Montero.png": 3507,
	"./selection-col/players/Camilo-Vargas.png": 3947,
	"./selection-col/players/Carlos-Gomez.png": 1322,
	"./selection-col/players/Daniel-Munoz.png": 1270,
	"./selection-col/players/David-Ospina.png": 4476,
	"./selection-col/players/Davinson-Sanchez.png": 8670,
	"./selection-col/players/Deiver-Machado.png": 2038,
	"./selection-col/players/Gustavo-Puerta.png": 2554,
	"./selection-col/players/James-Rodriguez.png": 721,
	"./selection-col/players/Jaminton-Campaz.png": 5952,
	"./selection-col/players/Jefferson-Lerma.png": 6005,
	"./selection-col/players/Jhon-Arias.png": 4503,
	"./selection-col/players/Jhon-Cordoba.png": 673,
	"./selection-col/players/Jhon-Lucumi.png": 5390,
	"./selection-col/players/Johan-Mojica.png": 339,
	"./selection-col/players/Jorge-Carrascal.png": 329,
	"./selection-col/players/Juan-Cucho.png": 6838,
	"./selection-col/players/Juan-Portilla.png": 9955,
	"./selection-col/players/Juan-Quintero.png": 5283,
	"./selection-col/players/Kevin-Castano.png": 4872,
	"./selection-col/players/Luis-Diaz.png": 3513,
	"./selection-col/players/Luis-Suarez.png": 5765,
	"./selection-col/players/Richard-Rios.png": 2768,
	"./selection-col/players/Santiago-Arias.png": 1288,
	"./selection-col/players/Willer-Ditta.png": 5695,
	"./selection-col/players/Yerri-Mina.png": 8658,
	"./selection-mx/players/Alexis-Vega.png": 6884,
	"./selection-mx/players/Alvaro-Fidalgo.png": 6054,
	"./selection-mx/players/Armando-Gonzalez.png": 8449,
	"./selection-mx/players/Brian-Gutierrez.png": 6546,
	"./selection-mx/players/Carlos-Acevedo.png": 554,
	"./selection-mx/players/Carlos-Rodriguez.png": 9550,
	"./selection-mx/players/Cesar-Huerta.png": 2918,
	"./selection-mx/players/Cesar-Montes.png": 6289,
	"./selection-mx/players/Denzell-Garcia.png": 8372,
	"./selection-mx/players/Edson-Alvarez.png": 9255,
	"./selection-mx/players/Erick-Lira.png": 3987,
	"./selection-mx/players/Erick-Sanchez.png": 5603,
	"./selection-mx/players/Everardo-Lopez.png": 6925,
	"./selection-mx/players/Gilberto-Mora.png": 5568,
	"./selection-mx/players/Guillermo-Martinez.png": 3217,
	"./selection-mx/players/Guillermo-Ochoa.png": 9475,
	"./selection-mx/players/Israel-Reyes.png": 743,
	"./selection-mx/players/Jesus-Angulo.png": 749,
	"./selection-mx/players/Jesus-Gallardo.png": 8733,
	"./selection-mx/players/Johan-Vasquez.png": 9702,
	"./selection-mx/players/Jorge-Sanchez.png": 2658,
	"./selection-mx/players/Julian-Quinones.png": 6698,
	"./selection-mx/players/Luis-Chavez.png": 7441,
	"./selection-mx/players/Luis-Romo.png": 2401,
	"./selection-mx/players/Mateo-Chavez.png": 3878,
	"./selection-mx/players/Obed-Vargas.png": 5785,
	"./selection-mx/players/Orbelin-Pineda.png": 8605,
	"./selection-mx/players/Raul-Jimenez.png": 291,
	"./selection-mx/players/Raul-Rangel.png": 3866,
	"./selection-mx/players/Richard-Ledezma.png": 7384,
	"./selection-mx/players/Roberto-Alvarado.png": 3444,
	"./selection-mx/players/Santiago-Gimenez.png": 7268
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5991;